import { doGetOrganization } from "services/public/organization";
import { useStore } from "stores/store";

export const fetchOrganization = async () => {
  const organization = await doGetOrganization();
  useStore.setState((state) => ({
    ...state,
    organization,
  }));
};
